import React from 'react';
import { graphql, compose } from 'react-apollo';
import { updateChurchGroup } from "./mutations/updateChurchGroup";
import { createChurchGroup } from "./mutations/createChurchGroup";
import { Icon, Input, Form, Button } from 'antd';
import Spinner from '../../../spinner/spinner';
import './editableCell.css';

const FormItem = Form.Item;

class EditableCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editable: false, added: this.props.added };
  }

  get updateMutationParams() {
    return {
      variables: {
        input: {
          id: this.props.groupId,
          name: this.props.form.getFieldValue('name')
        }
      }
    };
  }

  get createMutationParams() {
    return {
      variables: {
        input: {
          church_id: this.props.churchId,
          name: this.props.form.getFieldValue('name')
        }
      },
      update: this.props.onCreateGroup
    };
  }

  async submitData(params, submitAction) {
    try {
      this.setState({ loading: true });
      await submitAction(params);
      this.setState({ editable: false, added: false });
    } finally {
      this.setState({ loading: false });
    }
  }

  onCancelClick = () => {
    this.setState({ editable: false });
    this.props.form.resetFields();
    if (this.state.added) {
      this.props.onCancelClick();
    }
  };

  onEditClick = () => {
    this.setState({ editable: true });
  };

  onSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((error) => {
      if (!error) {
        if (this.state.editable) {
          this.submitData(this.updateMutationParams, this.props.updateChurchGroup);
        } else if(this.state.added) {
          this.submitData(this.createMutationParams, this.props.createChurchGroup)
        }
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { editable, loading, added } = this.state;

    if (editable || added) {
      return (
        <Form onSubmit={this.onSubmit} className="editable-cell">
          { loading && <Spinner/> }
          <div className="editable-cell-input-wrapper">
            <FormItem className="editable-cell__group-input">
              {getFieldDecorator('name', {
                rules: [
                  { required: true, message: 'Please input group name'},
                  { max: 255 }
                ],
                initialValue: this.props.value
              })(
                <Input autoFocus placeholder="Group name" disabled={loading}/>
              )}
            </FormItem>
            <FormItem>
              <Button htmlType="submit" className="editable-cell-button-submit" disabled={loading}>
                <Icon type="check" className="editable-cell-icon-check"/>
              </Button>
            </FormItem>
            <FormItem>
              <Icon type="close" className="editable-cell-icon-cancel" onClick={this.onCancelClick}/>
            </FormItem>
          </div>
        </Form>
      );
    } else {
      return (
        <div className="editable-cell">
          <div className="editable-cell-text-wrapper">
            {this.props.value}
            <Icon type="edit" className="editable-cell-icon" onClick={this.onEditClick}/>
          </div>
        </div>
      );
    }
  }
}

export default Form.create()(compose(
  graphql(updateChurchGroup, { name: 'updateChurchGroup' }),
  graphql(createChurchGroup, { name: 'createChurchGroup' })
)(EditableCell));



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/groups/editableCell.js